export default "__VITE_ASSET__CkVgHrT3__"